import { Form, Input, message, Modal, Select } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  createTrackingLinksRequest,
  updateTrackingLinksRequest,
} from "../../feature/tracking-links/trackingLinkSlice";
import { searchPartner } from "../../feature/referral-partners/referralPartnerApi";
import { getCommission } from "../../feature/commission-program/commissionApi";
import DebounceSelect from "../../components/DebounceSelect";
import { handleErrorSaga } from "../../utils/helper";

const AddTrackingLink = ({ onCancel, data }) => {
  const [listCommission, setListCommission] = useState([]);
  const dispatch = useDispatch();

  const [form] = Form.useForm();

  const onChangePartner = (value) => {
    if (value) {
      form.setFieldsValue({
        commissionPrograms: [],
      });
    }
  };

  const onChangeCommission = (value) => {
    if (value.length > 0) {
      form.setFieldsValue({
        partner: { label: "--/--", value: null },
      });
    }
  };

  const onCreate = (values) => {
    if (values.partner.value === null) {
      delete values.partner;
      if (data) {
        dispatch(updateTrackingLinksRequest({ ...values, _id: data._id }));
      } else {
        dispatch(createTrackingLinksRequest(values));
      }
    } else {
      delete values.commissionPrograms;
      if (data) {
        dispatch(
          updateTrackingLinksRequest({
            ...values,
            partner: values.partner.value,
            _id: data._id,
          })
        );
      } else {
        dispatch(
          createTrackingLinksRequest({
            ...values,
            partner: values.partner.value,
          })
        );
      }
    }
  };

  const fetchUserList = async (name) => {
    return searchPartner(name).then((res) => {
      const listPartner = res.data.map((partner) => ({
        label: `${partner.firstName} ${partner.lastName}`,
        value: partner._id,
      }));
      listPartner.unshift({
        label: "--/--",
        value: null,
      });
      return listPartner;
    });
  };

  useEffect(() => {
    getCommission()
      .then((res) => setListCommission(res.data))
      .catch((error) => handleErrorSaga(error));
  }, []);

  useEffect(() => {
    if (data?.partner) {
      form.setFieldsValue({
        partner: {
          label: `${data.partner.firstName || ""} ${
            data.partner.lastName || ""
          }`,
          value: data.partner._id,
        },
      });
    } else {
      form.setFieldsValue({ partner: { label: "--/--", value: null } });
    }
  }, [data, form]);

  useEffect(() => {
    if (listCommission.length > 0 && data?.commissionPrograms.length > 0) {
      form.setFieldsValue({
        commissionPrograms: data.commissionPrograms.map((item) => item._id),
      });
    } else {
      form.setFieldsValue({ commissionPrograms: [] });
    }
  }, [listCommission, data, form]);

  return (
    <Modal
      title={data ? "Update Tracking Link" : "Add Tracking Link"}
      visible={true}
      width={"80%"}
      className="modal-w-600"
      onOk={() => {
        form
          .validateFields()
          .then((values) => {
            onCreate(values);
            form.resetFields();
            onCancel();
          })
          .catch((info) => {
            message.error("Validate failed!");
            console.log("Validate Failed:", info);
          });
      }}
      onCancel={() => {
        form.resetFields();
        onCancel();
      }}
    >
      <div className="add-tracking-link-container">
        <Form
          form={form}
          name="basic"
          className="row-col"
          initialValues={{
            name: data?.name || "",
            code: data?.code || "",
            link: data?.link || "",
          }}
        >
          <Form.Item
            className="custom-form-item"
            name="name"
            label="Name&#42;"
            rules={[{ required: true, message: "Please input name!" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            className="custom-form-item"
            name="code"
            label="Code (no spaces, keep it short)&#42;"
            rules={[
              { required: true, message: "Please input code!" },
              {
                pattern: new RegExp("^[a-zA-Z0-9]*$"),
                message:
                  "Value is only number & char, no special char, no space",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            className="custom-form-item"
            name="link"
            label="Website Address&#42;"
            rules={[
              { required: true, message: "Please input link!" },
              {
                type: "url",
                message: "The input is not valid website address",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            className="custom-form-item"
            name="partner"
            label="Assign this Tracking Link to this one Referral Partner"
          >
            <DebounceSelect
              className="w-100-p"
              fetchOptions={fetchUserList}
              onChange={onChangePartner}
            />
          </Form.Item>
          <Form.Item
            className="custom-form-item"
            name="commissionPrograms"
            label="Assign this Tracking Link to all Partners belong to these Commission
          Programs below"
          >
            <Select
              className="w-100-p"
              mode="multiple"
              onChange={onChangeCommission}
            >
              {listCommission.map((item) => (
                <Select.Option key={item._id} value={item._id}>
                  {item.title}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
      </div>
    </Modal>
  );
};

export default AddTrackingLink;
